var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',[_c('app-banner'),_c('app-wrapper',{staticClass:"services"},[_c('app-wrapper',{staticClass:"services-content",attrs:{"content":true,"text":true,"inverse":true}},_vm._l((_vm.$state.page.services),function(item,index){return _c('app-service',{key:index,attrs:{"item":item}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }